enum ActionType {
    REQUEST_LOCATION_TAGS_SUMMARY = '[DASHBOARD/LOCATION_TAGS_SUMMARY] GET LOCATION TAGS SUMMARY',
    RECEIVE_LOCATION_TAGS_SUMMARY = '[DASHBOARD/LOCATION_TAGS_SUMMARY] SET LOCATION TAGS SUMMARY',
}

export default ActionType
